import * as PIXI from 'pixi.js';
import { APP_WIDTH, APP_HEIGHT, redrawFullScreenOverlay } from '../utils/commonUtils';
import AssetsLoader from '../utils/assetsLoader';

import CardContainer from './cardContainer';
import ActionButtonsContainer from './actionButtonsContainer';

export default class RevealCardsContainer extends PIXI.Container {
    constructor() {
        super();

        const searchDeckOverlayGraphics = new PIXI.Graphics();
        searchDeckOverlayGraphics.label = 'searchDeckOverlayGraphics';
        searchDeckOverlayGraphics.x = 0;
        searchDeckOverlayGraphics.y = 0;
        searchDeckOverlayGraphics.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        searchDeckOverlayGraphics.fill({ color: '#000000' });
        searchDeckOverlayGraphics.alpha = 0.7;
        this.addChild(searchDeckOverlayGraphics);

        this.titleText = new PIXI.Text({
            text: 'Select a Target',
            style: {
                fontFamily: 'Caladea',
                fontWeight: '700',
                fontSize: 90,
                fill: '#ee8d1b',
            },
        });
        this.titleText.anchor.set(0.5, 1);
        this.titleText.x = 0;
        this.titleText.y = -600;
        this.addChild(this.titleText);

        this.subTitleText = new PIXI.Text({
            text: '',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 54,
                fill: '#ffffff',
            },
        });
        this.subTitleText.anchor.set(0.5, 1);
        this.subTitleText.x = 0;
        this.subTitleText.y = -520;
        this.addChild(this.subTitleText);

        const lineGradient = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0.5 },
            end: { x: 1, y: 0.5 },
            colorStops: [
                { offset: 0, color: 'rgba(255, 255, 255, 0)' },
                { offset: 0.25, color: 'rgba(255, 255, 255, 1)' },
                { offset: 0.75, color: 'rgba(255, 255, 255, 1)' },
                { offset: 1, color: 'rgba(255, 255, 255, 0)' },
            ],
        });

        const lineGraphics1 = new PIXI.Graphics();
        lineGraphics1.label = 'lineGraphics1';
        lineGraphics1.x = 0;
        lineGraphics1.y = -500;
        lineGraphics1.rect(-APP_WIDTH / 2 + 50, -2, APP_WIDTH - 100, 4);
        lineGraphics1.fill(lineGradient);
        this.addChild(lineGraphics1);

        this.cardContainer = new CardContainer();
        this.cardContainer.label = 'cardContainer';
        this.cardContainer.x = 0;
        this.cardContainer.y = 435;
        this.cardContainer.scale.set(3);
        this.addChild(this.cardContainer);

        this.actionButtonsContainer = new ActionButtonsContainer();
        this.actionButtonsContainer.label = 'actionButtonsContainer';
        this.actionButtonsContainer.x = 0;
        this.actionButtonsContainer.y = 650;
        this.actionButtonsContainer.update({ clientGameState: { availableActions: ['CONFIRM'] } });
        this.addChild(this.actionButtonsContainer);

        this.waitingForOtherPlayerText = new PIXI.Text({
            text: 'Waiting for other Player to confirm reveal...',
            style: {
                fontFamily: 'Open Sans',
                fontWeight: '700',
                fontSize: 45,
                fill: '#ffffff',
            },
        });
        this.waitingForOtherPlayerText.anchor.set(0.5, 1);
        this.waitingForOtherPlayerText.x = 0;
        this.waitingForOtherPlayerText.y = 650;
        this.addChild(this.waitingForOtherPlayerText);
    }

    update(gameState) {
        if (gameState.pendingAction?.type !== 'EFFECT_STEP_RESOLUTION' ||
            gameState.pendingAction?.expectedResponseType !== 'revealCards') {
            return;
        }

        const { title, subtitle } = gameState.pendingAction.currentStepData || {};
        this.titleText.text = title || 'Card Revealed';
        this.subTitleText.text = subtitle || '';
    
        const card = gameState.pendingAction.cards[0];
        if (card) {
            this.cardContainer.updateCardInstance(card);
            this.cardContainer.hidePowerText();
        }

        if (gameState.pendingAction.revealPlayerId === gameState.player.playerId) {
            this.waitingForOtherPlayerText.visible = true;
            this.actionButtonsContainer.visible = false;
        } else {
            this.waitingForOtherPlayerText.visible = false;
            this.actionButtonsContainer.visible = true;
        }
    
    }

    resize(width, height) {
        redrawFullScreenOverlay(this.getChildByLabel('searchDeckOverlayGraphics'), width, height);
    }
}